export enum STATUS {
  REQUEST = 'In Progress',
  COMPLETED = 'Complete',
  ARCHIVED = 'Archived',
}
